import { Page } from "@/models/page-models/Page";

export const CustomerServiceDashboard: Page = {
  "path": "customer-service-dashboard",
  "name": "Customer Service Dashboard",
  "props": {
    "data": {
      "title": "Dashboard",
      "printable": "FALSE",
      "url": "customer-service-dashboard",
      "groups": [
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "Call Off",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.pendingCalloffs.data}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "FG",
                      "disabled": "FALSE",
                      "items": "fetchedData.pendingCalloffs.data",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "CallOff #"
                        },
                        {
                          "value": "__item.quotationId",
                          "text": "SO #",
                           "type": "custom-url",
                           "customUrlFns": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "openQtInNewTab",
                                "type": "fnRedirect",
                                "arg1Key": "redirectUrl",
                                "arg1Value": "/view-sales-contract/{{__item.quotationId}}",
                                "arg2Key": "openNewTab",
                                "arg2Value": "TRUE"
                              },
                              "name": "openQtInNewTab"
                            }
                          ]
                        },
                        {
                          "value": "__item.customerPO",
                          "text": "PO#"
                        },
                        {
                          "value": "__item.customer",
                          "text": "Customer",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,{{__item.quantity}})"
                        },
                        {
                          "value": "__item.unit.unit2",
                          "text": "Selling Unit"
                        },
                        {
                          "value": "__item.FOC",
                          "text": "FOC",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,{{__item.FOC}})",
                          "showIf": "fn(ARRAY_SUM,{{__item.FOC}},{{fetchedData.pendingCalloffs.data}})"
                        },
                        {
                          "value": "__item.targetDate",
                          "text": "Target Date",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.targetDate}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        },
                        {
                          "value": "__item.target",
                          "text": "Target",
                          "formula": "fn(HELPER_FN,orderTarget,{{__item.target}})"
                        }
                      ],
                      "tableType": "static",
                      "neverHideActionBar": true,
                      "selectableUniqueId": "_id",
                      "singleSelect": true,
                      "groupActions": [
                        {
                          "label": "Add To Target",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copySelectedOrder"
                            },
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "copyDefaultTargetForm",
                                "type": "fnCopyData",
                                "arg1Key": "sourceFn",
                                "arg1Value": "getDefaultTargetForm",
                                "arg2Key": "destinationKey",
                                "arg2Value": "formData",
                                "arg3Key": "destinationKeyType",
                                "arg3Value": "Object",
                                "arg4Key": "append",
                                "arg4Value": "TRUE",
                                "arg5Key": "sourceKey",
                                "arg5Value": "__item"
                              },
                              "name": "copyDefaultTargetForm"
                            },
                            {
                              "executionOrder": 2,
                              "pageFunction": {
                                "name": "openAddToTargetPopup",
                                "type": "fnOpenPopup",
                                "arg1Key": "popupName",
                                "arg1Value": "Add To Target"
                              },
                              "name": "openAddToTargetPopup"
                            }
                          ]
                        },
                        {
                          "label": "Mark As Complete",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "markCalloffAsComplete",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/callOff/{{__item._id}}/mark-completed",
                                "arg2Key": "postData",
                                "arg2Value": "\"{}\"",
                                "arg3Key": "requestMethod",
                                "arg3Value": "PATCH"
                              },
                              "executeIf": "fn(LOGICAL,fn(CONCAT,',{{__item.status}},'),==,'Invoiced')",
                              "name": "markCalloffAsComplete"
                            },
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "markPendingCalloffAsComplete",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/callOff/{{__item._id}}/mark-pending-to-completed",
                                "arg2Key": "postData",
                                "arg2Value": "\"{}\"",
                                "arg3Key": "requestMethod",
                                "arg3Value": "PATCH"
                              },
                              "executeIf": "fn(LOGICAL,fn(CONCAT,',{{__item.status}},'),==,'Pending')",
                              "name": "markCalloffAsComplete"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getPendingCalloffs"
                            }
                          ]
                        }
                      ],
                      "height": "69vh"
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Transfer",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.FgRequests}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "FG",
                      "disabled": "FALSE",
                      "items": "fetchedData.FgRequests",
                      "tableType": "static",
                      "showActions": true,
                      "headers": [
                        {
                          "value": "__item.rawMaterial._id",
                          "text": "Good#"
                        },
                        {
                          "value": "__item.rawMaterial.factoryTicket.order.product.customerName",
                          "text": "Customer"
                        },
                        {
                          "value": "__item.rawMaterial.factoryTicket.order._id",
                          "text": "Order #",
                          "type": "custom-url",
                          "width": 80,
                          "customUrlFns": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "openOrderInNewTab",
                                "type": "fnRedirect",
                                "arg1Key": "redirectUrl",
                                "arg1Value": "/order/{{__item.rawMaterial.factoryTicket.order._id}}",
                                "arg2Key": "openNewTab",
                                "arg2Value": "TRUE"
                              },
                              "name": "openOrderInNewTab"
                            }
                          ]
                        },
                        {
                          "value": "__item.rawMaterial.factoryTicket.order.product",
                          "text": "Product Description",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.rawMaterial.factoryTicket.order.product}})"
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Quantity to be Moved",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,fn(HELPER_FN,kgToSellingUnitQuantity,{{__item.rawMaterial.factoryTicket.order}},{{__item.rawMaterial}},{{__item.quantity}}))"
                        },
                        {
                          "value": "__item.rawMaterial.factoryTicket.order.product.unit.unit2",
                          "text": "Selling Unit"
                        },
                        {
                          "value": "__item.createdAt",
                          "text": "Date Created",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        },
                        {
                          "value": "__item.actions",
                          "text": "Actions",
                          "type": "actions",
                          "width": 150,
                          "actions": [
                            {
                              "label": "Approve",
                              "priority": "main",
                              "onClick": [
                                {
                                  "executionOrder": 1,
                                  "pageFunction": {
                                    "name": "approveTransferRequest",
                                    "type": "fnSubmit",
                                    "arg1Key": "apiUrl",
                                    "arg1Value": "/api/v1/goods/transfer/{{__item._id}}/approve",
                                    "arg2Key": "postData",
                                    "arg2Value": "{}"
                                  },
                                  "name": "approveTransferRequest"
                                },
                                {
                                  "executionOrder": 2,
                                  "pageFunction": {
                                    "name": "getPendingTransferRequests",
                                    "type": "fnGetData",
                                    "arg1Key": "apiUrl",
                                    "arg1Value": "/api/v1/goods/transfer/pending",
                                    "arg2Key": "storeInVar",
                                    "arg2Value": "fetchedData.transferRequests"
                                  },
                                  "name": "getPendingTransferRequests"
                                },
                                {
                                  "executionOrder": 3,
                                  "pageFunction": {
                                    "name": "getFgRequests",
                                    "type": "fnCopyData",
                                    "arg1Key": "sourceFn",
                                    "arg1Value": "filterFgRequests",
                                    "arg2Key": "destinationKey",
                                    "arg2Value": "fetchedData.FgRequests"
                                  },
                                  "name":"getFgRequests"
                                }
                              ]
                            },
                            {
                              "label": "Reject",
                              "priority": "menu",
                              "onClick": [
                                {
                                  "executionOrder": 1,
                                  "pageFunction": {
                                    "name": "rejectTransferRequest",
                                    "type": "fnSubmit",
                                    "arg1Key": "apiUrl",
                                    "arg1Value": "/api/v1/goods/transfer/{{__item._id}}/reject",
                                    "arg2Key": "postData",
                                    "arg2Value": "{}"
                                  },
                                  "name": "rejectTransferRequest"
                                },
                                {
                                  "executionOrder": 2,
                                  "pageFunction": {
                                    "name": "getPendingTransferRequests",
                                    "type": "fnGetData",
                                    "arg1Key": "apiUrl",
                                    "arg1Value": "/api/v1/goods/transfer/pending",
                                    "arg2Key": "storeInVar",
                                    "arg2Value": "fetchedData.transferRequests"
                                  },
                                  "name": "getPendingTransferRequests"
                                },
                                {
                                  "executionOrder": 3,
                                  "pageFunction": {
                                    "name": "getFgRequests",
                                    "type": "fnCopyData",
                                    "arg1Key": "sourceFn",
                                    "arg1Value": "filterFgRequests",
                                    "arg2Key": "destinationKey",
                                    "arg2Value": "fetchedData.FgRequests"
                                  },
                                  "name":"getFgRequests"
                                }
                              ]
                            }
                          ],
                          "useMenu": true
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Complete",
              "bracketValueFormula": "{{fetchedData.ordersPendingCompletion.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Orders Pending Dispatch",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.ordersPendingCompletion.data}}",
                      "items": "fetchedData.ordersPendingCompletion.data.docs",
                      "headers": [
                        {
                          "value": "_id",
                          "text": "Order #",
                          "type": "custom-url",
                          "width": 80,
                          "customUrlFns": [
                            {
                              "executionOrder": 1,
                              "name": "openOrderInNewTab"
                            }
                          ]
                        },
                        {
                          "value": "factoryTicket",
                          "text": "FT #",
                          "type": "url",
                          "url": "/factory-ticket/{{__item.factoryTicket}}"
                        },
                        {
                          "value": "__item.callOff._id",
                          "text": "CallOff #"
                        },
                        {
                          "value": "__item.customerPO",
                          "text": "Customer PO#"
                        },
                        {
                          "value": "productionStatusString",
                          "text": "Production Status",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currentFTProgress,{{__item.currentFTProgress}})"
                        },
                        {
                          "value": "__item.deliveryDate",
                          "text": "Delivery Date",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.deliveryDate}})"
                        },
                        {
                          "value": "__item.customer.name",
                          "text": "Customer",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})",
                          "variableType": "item"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.product.repeatType",
                          "text": "Product Type",
                          "type": "productRepeatType"
                        },
                        {
                          "value": "__item.unit.unit2",
                          "text": "Unit",
                          "width": 70
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Order Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,fn(SUM,{{__item.quantity}},{{__item.FOC}}))"
                        },
                        {
                          "value": "balance.totalQuantityProduced",
                          "text": "Produced Qty",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,{{__item.balance.totalQuantityProduced}})"
                        },
                        {
                          "value": "balanceQuantity",
                          "text": "Balance Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,fn(SUBTRACT,fn(SUM,{{__item.quantity}},{{__item.FOC}}),{{__item.balance.totalQuantityProduced}}))"
                        },
                        {
                          "value": "__item.status",
                          "text": "Order Status"
                        },
                        {
                          "value": "__item.callOff.target",
                          "text": "Target",
                          "formula": "fn(HELPER_FN,orderTarget,{{__item.callOff.target}})"
                        }
                      ],
                      "tableType": "static",
                      "showActions": true,
                      "selectableUniqueId": "_id",
                      "enableSearch": true,
                      "searchFunctions": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyOrdersPendingCompletionSearchString",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__item",
                            "arg2Key": "sourceFn",
                            "arg2Value": "getSearchString",
                            "arg3Key": "destinationKey",
                            "arg3Value": "fetchedData.ordersPendingCompletionForm",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object",
                            "arg5Key": "append",
                            "arg5Value": "TRUE"
                          },
                          "name": "copyOrdersPendingCompletionSearchString"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getOrdersPendingCompletion"
                        }
                      ],
                      "groupActions": [
                        {
                          "label": "Mark As Complete",
                          "priority": "main",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "markOrderAsDelivered"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersPendingCompletion",
                              "executeOnce": true
                            }
                          ]
                        },
                        {
                          "label": "Cancel Order",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "cancelOrder"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersPendingCompletion",
                              "executeOnce": true
                            }
                          ]
                        },
                        {
                          "label": "Update Customer PO",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copySelectedOrder"
                            },
                            {
                              "executionOrder": 2,
                              "name": "openCustomerPoPopup"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "height": "69vh",
                      "pagination": {
                        "pageVariable": "fetchedData.ordersPendingCompletionForm.page",
                        "serverItemsLengthVariable": "fetchedData.ordersPendingCompletion.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getOrdersPendingCompletion"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.ordersPendingCompletion.data.limit"
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Hold",
              "bracketValueFormula": "{{fetchedData.ordersOnHold.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Orders On Hold",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.ordersOnHold.data}}",
                      "items": "fetchedData.ordersOnHold.data.docs",
                      "headers": [
                        {
                          "value": "_id",
                          "text": "Order #",
                          "type": "custom-url",
                          "width": 80,
                          "customUrlFns": [
                            {
                              "executionOrder": 1,
                              "name": "openOrderInNewTab"
                            }
                          ]
                        },
                        {
                          "value": "factoryTicket",
                          "text": "FT #",
                          "type": "url",
                          "url": "/factory-ticket/{{__item.factoryTicket}}"
                        },
                        {
                          "value": "__item.callOff._id",
                          "text": "CallOff #"
                        },
                        {
                          "value": "__item.customerPO",
                          "text": "Customer PO#"
                        },
                        {
                          "value": "productionStatusString",
                          "text": "Production Status",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currentFTProgress,{{__item.currentFTProgress}})"
                        },
                        {
                          "value": "__item.deliveryDate",
                          "text": "Delivery Date",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.deliveryDate}})"
                        },
                        {
                          "value": "__item.customer.name",
                          "text": "Customer",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})",
                          "variableType": "item"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.product.repeatType",
                          "text": "Product Type",
                          "type": "productRepeatType"
                        },
                        {
                          "value": "__item.unit.unit2",
                          "text": "Unit",
                          "width": 70
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Order Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,fn(SUM,{{__item.quantity}},{{__item.FOC}}))"
                        },
                        {
                          "value": "balance.totalQuantityProduced",
                          "text": "Produced Qty",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,{{__item.balance.totalQuantityProduced}})"
                        },
                        {
                          "value": "balanceQuantity",
                          "text": "Balance Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,fn(SUBTRACT,fn(SUM,{{__item.quantity}},{{__item.FOC}}),{{__item.balance.totalQuantityProduced}}))"
                        },
                        {
                          "value": "__item.status",
                          "text": "Order Status"
                        },
                        {
                          "value": "__item.callOff.target",
                          "text": "Target",
                          "formula": "fn(HELPER_FN,orderTarget,{{__item.callOff.target}})"
                        }
                      ],
                      "tableType": "static",
                      "showActions": true,
                      "selectableUniqueId": "_id",
                      "enableSearch": true,
                      "searchFunctions": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyOrdersOnHoldSearchString",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__item",
                            "arg2Key": "sourceFn",
                            "arg2Value": "getSearchString",
                            "arg3Key": "destinationKey",
                            "arg3Value": "fetchedData.ordersOnHoldForm",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object",
                            "arg5Key": "append",
                            "arg5Value": "TRUE"
                          },
                          "name": "copyOrdersOnHoldSearchString"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getOrdersOnHold"
                        }
                      ],
                      "groupActions": [
                        {
                          "label": "Cancel Order",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "cancelOrder"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersOnHold",
                              "executeOnce": true
                            }
                          ]
                        },
                        {
                          "label": "Mark As Under Production",
                          "priority": "menu",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),<,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "markAsUnderProduction"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersOnHold",
                              "executeOnce": true
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersPendingCompletion",
                              "executeOnce": true
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "height": "69vh",
                      "pagination": {
                        "pageVariable": "fetchedData.ordersOnHoldForm.page",
                        "serverItemsLengthVariable": "fetchedData.ordersOnHold.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getOrdersOnHold"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.ordersOnHold.data.limit"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Update Customer PO",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.customerPO",
                  "label": "Customer PO",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Update",
              "onClick": [
                {
                  "executionOrder": 1,
                  "name": "updateCustomerPO"
                },
                {
                  "executionOrder": 2,
                  "name": "closeCustomerPoPopup"
                }
              ]
            }
          ],
          "width": "500"
        },
        {
          "type": "popupGroup",
          "label": "Change Delivery Date",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "fetchedData.selectedOrder",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,orderDescription,{{fetchedData.selectedOrder}})"
                },
                {
                  "type": "datepicker",
                  "variable": "formData.deliveryDate",
                  "label": "Delivery Date",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Submit",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "submitDeliveryDate",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/order/update/{{fetchedData.selectedOrder._id}}/delivery-date",
                    "arg2Key": "postData",
                    "arg2Value": "formData",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE"
                  },
                  "name": "submitDeliveryDate"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "closeDeliveryDatePopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Change Delivery Date"
                  },
                  "name": "closeDeliveryDatePopup"
                }
              ]
            }
          ],
          "width": "500"
        },
        {
          "type": "popupGroup",
          "label": "Add To Target",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.quantity",
                  "label": "Target Quantity",
                  "disabled": "FALSE",
                  "unit": "{{fetchedData.selectedOrder.product.packingMode.0.unit1}}"
                },
                {
                  "type": "datepicker",
                  "variable": "formData.month",
                  "label": "Month",
                  "disabled": "FALSE",
                  "minDateFormula": "{{MONTH_START}}",
                  "maxDateFormula": "{{MONTH_END}}",
                  "showWeekNumber": true
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Add To Target",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "addToTarget",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/callOff/{{fetchedData.selectedOrder._id}}/add-to-target",
                    "arg2Key": "postData",
                    "arg2Value": "formData",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE"
                  },
                  "name": "addToTarget"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "closeTargetPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Add To Target"
                  },
                  "name": "closeTargetPopup"
                }
              ]
            }
          ],
          "width": "500"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "copyOrdersOnHoldForm"
      },
      {
        "executionOrder": 2,
        "name": "getOrdersOnHold"
      },
      {
        "executionOrder": 1,
        "name": "copyOrdersPendingCompletionForm"
      },
      {
        "executionOrder": 2,
        "name": "getOrdersPendingCompletion"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getPendingTransferRequests",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/goods/transfer/pending",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.transferRequests"
        },
        "name": "getPendingTransferRequests"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getFgRequests",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "filterFgRequests",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.FgRequests"
        },
        "name":"getFgRequests"
      },
      {
        "executionOrder": 2,
        "name": "getPendingCalloffs"
      }
    ],
    "functions": [
      {
        "name": "getPendingCalloffs",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/quotation/get-pending-call-off",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.pendingCalloffs"
      },
      {
        "name": "getOrdersOnHold",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/order/get",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.ordersOnHold",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.ordersOnHoldForm"
      },
      {
        "name": "getOrdersPendingCompletion",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/order/get",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.ordersPendingCompletion",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.ordersPendingCompletionForm"
      },
      {
        "name": "copySelectedOrder",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedOrder"
      },
      {
        "name": "markProductionHoldStatus",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/order/{{__item._id}}/mark-production-hold",
        "arg2Key": "postData",
        "arg2Value": "\"{}\""
      },
      {
        "name": "markOrderAsDelivered",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/order/{{__item._id}}/mark-delivered",
        "arg2Key": "postData",
        "arg2Value": "\"{}\""
      },
      {
        "name": "cancelOrder",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/order/{{__item._id}}/cancel-production-order",
        "arg2Key": "postData",
        "arg2Value": "\"{}\""
      },
      {
        "name": "markAsUnderProduction",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/order/{{__item._id}}/mark-under-production",
        "arg2Key": "postData",
        "arg2Value": "\"{}\""
      },
      {
        "name": "openOrderInNewTab",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/order/{{__item._id}}",
        "arg2Key": "openNewTab",
        "arg2Value": "TRUE"
      },
      {
        "name": "openPendingOrderInNewTab",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/order/{{__item.order._id}}",
        "arg2Key": "openNewTab",
        "arg2Value": "TRUE"
      },
      {
        "name": "getFilteredOrdersPendingProductionReports",
        "type": "fnFilterArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.productionReports.orders",
        "arg2Key": "searchKey",
        "arg2Value": "order.status",
        "arg3Key": "formulaCondition",
        "arg3Value": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{__item.order.status}},'),==,'Under Production'),||,fn(LOGICAL,fn(CONCAT,',{{__item.order.status}},'),==,'Invoice Issued'))"
      },
      {
        "name": "openCustomerPoPopup",
        "type": "fnOpenPopup",
        "arg1Key": "popupName",
        "arg1Value": "Update Customer PO"
      },
      {
        "name": "updateCustomerPO",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/order/{{fetchedData.selectedOrder._id}}/update-customer-po\n",
        "arg2Key": "refreshPage",
        "arg2Value": "TRUE"
      },
      {
        "name": "closeCustomerPoPopup",
        "type": "fnClosePopup",
        "arg1Key": "popupName",
        "arg1Value": "Update Customer PO"
      },
      { 
        "name": "getDefaultTargetForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "quantity": "fn(HELPER_FN,orderQuantityInBaseUnit,{{fetchedData.selectedOrder}})",
          "month": "fn(HELPER_FN,dateFormat,{{MONTH_END}},date-picker)"
        },
        "useFormula": true
      },
      {
        "name": "copyOrdersOnHoldForm",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getOrdersOnHoldForm",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.ordersOnHoldForm",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object"
      },
      { 
        "name": "getOrdersOnHoldForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "orderStatus": "Hold"
        },
        "staticObject": true
      },
      {
        "name": "copyOrdersPendingCompletionForm",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getOrdersPendingCompletionForm",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.ordersPendingCompletionForm",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object"
      },
      { 
        "name": "getOrdersPendingCompletionForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "orderStatus": "Pending Completion"
        },
        "staticObject": true
      },
      {
        "name": "getSearchString",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": "1",
          "search": "{{__selectedObject}}"
        },
        "useFormula": true
      },
      {
        "name": "filterFgRequests",
        "type": "fnFilterArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.transferRequests.data",
        "arg2Key": "searchKey",
        "arg2Value": "rawMaterial.status",
        "arg3Key": "searchValue",
        "arg3Value": "FG"
      }
    ]
  },
  "forRole": "CUSTOMER_SERVICE_MANAGER",
  "visible": true,
  "routerPriority": 100
}